module.exports = __webpack_public_path__ + "img/lion-parcel-red.f2f92d45.svg";